/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

 import React from "react";
 import { Redirect, Switch, Route } from "react-router-dom";
 import { shallowEqual, useSelector } from "react-redux";
 import { Layout } from "../_metronic/layout";
 import BasePage from "./BasePage";
 import BasePageAdmin from "./BasePageAdmin";
 import { Logout, AuthPage, Simulate, StopSimulate } from "./modules/Auth";
 import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
 
 export function Routes() {
   const { isAuthorized, isAdmin, isSimulating } = useSelector(
     ({ auth }) => ({
       isAuthorized: auth.user !== null && auth.user !== undefined,
       isAdmin: auth.user !== null && auth.user !== undefined ? auth.user.roles.includes(0) ? true : false : false,
       isSimulating: auth.user !== null && auth.user !== undefined ? auth.user.roles.includes(0) && auth.user.client.id !== undefined ? true : false : false
     }),
     shallowEqual
   );
 
   return (
     <Switch>
       {(!isAuthorized || window.location.href.includes('reset-password') || window.location.href.includes('forgot-password')) ? (
         /*Render auth page when user at `/auth` and not authorized.*/
         <Route>
           <AuthPage />
         </Route>
       ) : (
         /*Otherwise redirect to root page (`/`)*/
         <Redirect from="/auth" to="/" />
       )}
       <Route path="/error" component={ErrorsPage} />
       <Route path="/logout" component={Logout} />
       <Route path="/simulate/:id/:productid">
       {({ history, match }) => (
           <Simulate
             id={match && match.params.id}
             productid={match && match.params.productid}
           />
         )}
       </Route>
       <Route path="/simulate/:id">
       {({ history, match }) => (
           <Simulate
             id={match && match.params.id}
           />
         )}
       </Route>
       
       <Route path="/unsimulate" component={StopSimulate} />
 
       {!isAuthorized ? (
         <Redirect to="/auth/login" />
       ) : (
         <Layout>
         {isAdmin && !isSimulating
           ? <BasePageAdmin />
           : <BasePage />
         }
         </Layout>
       )}
     </Switch>
   );
 }
 